function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Sans"
    },
    d: "M 25 2 C 12.309296 2 2 12.309296 2 25 C 2 37.690704 12.309296 48 25 48 C 37.690704 48 48 37.690704 48 25 C 48 12.309296 37.690704 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 24.90625 11.96875 A 1.0001 1.0001 0 0 0 24.78125 12 A 1.0001 1.0001 0 0 0 24.6875 12.03125 A 1.0001 1.0001 0 0 0 24.59375 12.0625 A 1.0001 1.0001 0 0 0 24.40625 12.1875 A 1.0001 1.0001 0 0 0 24.28125 12.28125 A 1.0001 1.0001 0 0 0 24.15625 12.4375 L 16.28125 20.28125 A 1.016466 1.016466 0 1 0 17.71875 21.71875 L 24 15.4375 L 24 37 A 1.0001 1.0001 0 1 0 26 37 L 26 15.4375 L 32.28125 21.71875 A 1.016466 1.016466 0 1 0 33.71875 20.28125 L 25.84375 12.4375 A 1.0001 1.0001 0 0 0 25.5625 12.15625 A 1.0001 1.0001 0 0 0 25.1875 12 A 1.0001 1.0001 0 0 0 24.90625 11.96875 z",
    overflow: "visible",
    fontFamily: "Sans"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.a8dd17443cd7ab21af7a9124fce64aeb.svg";
export { ForwardRef as ReactComponent };